module.exports = __webpack_public_path__ + "img/dk.27a0d693.svg";